function detectDarkOrLightTheme() {
  setTimeout(() => {
    const scheme = window.matchMedia("(prefers-color-scheme:dark)").matches
      ? 'dark-theme'
      : 'light-theme';

    window.pagesense = window.pagesense || [];
    window.pagesense.push(['trackEvent', scheme]);
  }, 800);
}

/* globalTrackers.js — Storefront dataLayer pushes */
window.dataLayer = window.dataLayer || [];
window.__dl_fired = window.__dl_fired || {};
const MP_LOADER = 'shopify_theme';

/* ---------- Helpers (mantendo shape/props) ---------- */
const normalizeId = (id) => {
  if (!id) return null;
  const s = String(id);
  let m = s.match(/shopify_[a-zA-Z]{2}_(\d+)_\d+/);
  if (m && m[1]) return m[1];
  m = s.match(/gid:\/\/shopify\/[A-Za-z]+\/(\d+)/);
  if (m && m[1]) return m[1];
  m = s.match(/(\d{5,})/);
  return m ? m[1] : s;
};
const p2 = v => Math.round(Number(v || 0) * 100) / 100;

const getVariantTitle = (variant, product) =>
  (variant && (variant.title || variant.name || variant.public_title)) ||
  (product && product.variant_title) ||
  (window.ShopifyAnalytics && ShopifyAnalytics.meta?.selectedVariant?.name) ||
  (window.ShopifyAnalytics && ShopifyAnalytics.meta?.selectedVariant?.public_title) ||
  document.querySelector('form#product-form')?.dataset?.variantTitle ||
  null;

// Events disparados por default pelo app Google & YouTube
/*
De acordo com a documentação oficial do Shopify e Google, os eventos de conversão predefinidos são:
: purchase – quando uma compra é concluída
: add_to_cart – quando um produto é adicionado ao carrinho
: begin_checkout – ao iniciar o checkout

Além desses eventos principais de conversão, o app também sugere ações de observação (não usadas para otimização de campanhas, mas úteis nas relatórios):
: page_view
: view_item
: search
*/

function mapCartItems(cart) {
  return (cart.items || []).map(item => ({
    item_id: item.product_id,
    item_name: item.product_title || item.title || null,
    item_variant: item.variant_id || null,
    item_brand: item.vendor || null,
    item_category: item.product_type || null,
    item_sku: item.sku || null,
    price: (item.price ?? 0) / 100,
    quantity: item.quantity ?? 0,
  }));
}

let cartViewedLoaded = false;
function fireCartViewed() {
  const path = (window.location.pathname || '').toLowerCase().replace(/\/$/, '');
  if (path !== '/cart' || cartViewedLoaded) return;
  cartViewedLoaded = true;

  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const currency = cart.currency || Shopify?.currency?.active || 'CAD';
      const value = (cart.total_price ?? 0) / 100;
      const items = mapCartItems(cart);

      window.dataLayer.push({
        event: 'view_cart',
        cart_context: 'page',
        page_location: location.href,
        mp_loader: MP_LOADER,
        event_source: 'shopify_theme',
        ecommerce: { currency, value, items },
        cart: {
          item_count: cart.item_count ?? 0,
          subtotal: (cart.items_subtotal_price ?? 0) / 100,
        },
      });
    });
}

function trackCartDrawerOpen() {
  let dlFired = false;

  document.documentElement.addEventListener('wetheme-toggle-right-drawer', evt => {
    const { type, forceOpen } = evt.detail || {};
    if (type !== 'cart') return;

    if (forceOpen === false) {
      dlFired = false;
      return;
    }
    if (dlFired) return;
    dlFired = true;

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const currency = cart.currency || Shopify?.currency?.active || 'CAD';
        const value = (cart.total_price ?? 0) / 100;
        const items = mapCartItems(cart);

        window.dataLayer.push({
          event: 'view_cart',
          cart_context: 'drawer',
          page_location: location.href,
          mp_loader: MP_LOADER,
          event_source: 'shopify_theme',
          ecommerce: { currency, value, items },
          cart,
        });
      });
  });
}

document.addEventListener('click', async event => {
  const removeBtn = event.target.closest('.cart-item-remove') ? event.target.closest('.cart-item-remove') : event.target.closest('.ajaxcart__qty-remove');
  if (!removeBtn || removeBtn.dataset.dlFired) return;
  removeBtn.dataset.dlFired = 'true';

  const item = removeBtn.closest('.cart-item');
  if (!item) return;

  const { key, productId, variantId, variantTitle, productTitle, price, quantity } = item.dataset;
  const itemName = productTitle || item.querySelector('.cart-item-title')?.textContent?.trim();
  const itemVariant = variantTitle || variantId;

  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });

    const currency = Shopify?.currency?.active || 'CAD';
    const priceNum = Number(price) || 0;
    const qtyNum = Number(quantity) || 0;
    const value = (priceNum / 100) * qtyNum;

    window.dataLayer.push({
      event: 'remove_from_cart',
      page_location: location.href,
      mp_loader: MP_LOADER,
      event_source: 'shopify_theme',
      ecommerce: {
        currency,
        value,
        items: [{
          item_id: productId,
          item_name: itemName,
          item_variant: itemVariant,
          item_brand: item.dataset.vendor,
          item_category: item.dataset.productType,
          item_sku: item.dataset.sku,
          price: priceNum / 100,
          quantity: qtyNum,
        }],
      },
    });
  } catch (err) {
    console.error('Error removing cart item:', err);
  }
});

window.addEventListener('DOMContentLoaded', () => {
  detectDarkOrLightTheme();
  trackCartDrawerOpen();
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', fireCartViewed);
} else {
  fireCartViewed();
}
